export default "__VITE_ASSET__CYBYa$Fo__"